import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    providerCredentialsContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    providerPillContainer: {
      display: 'flex',
      alignItems: 'center',
      background: '#f4f8f8',
      borderRadius: '50px',
      height: '100px',
      padding: '13px 31px 12px',
      maxWidth: 380,
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        height: '80px',
        padding: '15px 24px',
        marginTop: theme.spacing(4),
      },
    },
    providerPillText: {
      width: 'calc(100% - 70px)',
    },
    goBack: {
      position: 'absolute',
      '& a': {
        color: '#626f6f',
      }
    },
    credentialsText: {
      fontSize: '18px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.28',
      letterSpacing: 'normal',
      color: '#364343',
      marginTop: 32,
      marginBottom: 38,
    },
    topMargin: {
      marginTop: theme.spacing(5),
    },
  }),
);
